import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import getUrl from 'libraries/front-end-core/core/url'
import { ALL_AOLS, AOL_DISPLAY_NAMES } from 'constants/aol/aol'
import { LEGISLATION_MENU, LEGISLATION_FOLDERS } from 'constants/controllers'
import Breadcrumbs from 'components/Breadcrumbs'
import AOLDropdown from 'components/shared/AOLDropdown'
import { selectSelectedAols } from 'redux/selectors/selectSelectedAols'
import { setLegislationSelectedAols } from 'redux/actions'

export default ({ query }) => {
  const selectedAols = useSelector(selectSelectedAols)
  const dispatch = useDispatch()
  const handleOnSelect = (aol) => {
    dispatch(
      setLegislationSelectedAols(
        selectedAols.includes(aol)
          ? selectedAols.filter(selectedAol => selectedAol !== aol)
          : [...selectedAols, aol]
      )
    )
  }

  return (
    <div className='bg-page-background pv6'>
      <div className='layout-width-constraint flex justify-between items-center'>
        <Breadcrumbs
          crumbs={[{
            label: 'Legislation',
            href: getUrl(LEGISLATION_FOLDERS)
          }]}
          current={query.name}
          icon='legislation'
          viewAllLink={getUrl(LEGISLATION_MENU)}
        />
        <AOLDropdown
          multi
          align='left'
          options={ALL_AOLS.map(aol => ({
            value: aol,
            label: AOL_DISPLAY_NAMES[aol],
            selected: selectedAols.includes(aol)
          }))}
          handleOnSelect={handleOnSelect}
        />
      </div>
    </div>
  )
}
